export default __webpack_public_path__ + "images/logoUsaToday.4008f28c295cd87564c811e4a4a2f3f5.svg"